import axios from "axios";
import {
  AccessRequestPayload,
  UpdateAccessPayload,
} from "../../types/auth.types";

export const getToken = (hasToken: "0" | "1", email: string): Promise<any> => {
  const headers = {
    tenant_id: process.env.REACT_APP_TENANT_ID,
    client_id: process.env.REACT_APP_API_CLIENT_ID,
    client_secret: process.env.REACT_APP_API_CLIENT_SECRET,
  };

  return axios.get(`/api/login?hasToken=${hasToken}&email=${email}`, {
    headers,
  });
};

export const getUsers = (): Promise<any> => axios.get("/api/users");

export const sendUserRequest = (
  includeUser: "0" | "1",
  data: AccessRequestPayload
): Promise<any> => {
  return axios.get(
    `/api/access-request?includeUser=${includeUser}&data=${JSON.stringify(
      data
    )}`
  );
};

export const updateUserAccess = (data: UpdateAccessPayload): Promise<any> => {
  return axios.get(`/api/update-access?data=${JSON.stringify(data)}`);
};
